/**
 * Normalize NEXT_PUBLIC_PONDER_URL: trim, strip accidental JSON-style quotes (common when
 * copy-pasting into Railway), and trailing slashes. Ponder's client uses `new URL(baseUrl)`;
 * a leading `"` in the value produces Invalid URL at runtime/build.
 */
function normalizePonderEnv(raw: string | undefined): string {
  if (!raw) return '';
  let s = raw.trim();
  if ((s.startsWith('"') && s.endsWith('"')) || (s.startsWith("'") && s.endsWith("'"))) {
    s = s.slice(1, -1).trim();
  }
  return s.replace(/\/+$/, '');
}

/** Ponder origin for REST routes (leaderboard, personal-best). Strips a trailing `/sql` if present. */
export function getPonderHttpBase(): string {
  const s = normalizePonderEnv(process.env.NEXT_PUBLIC_PONDER_URL);
  if (!s) return '';
  return s.endsWith('/sql') ? s.slice(0, -4) : s;
}

/** Base URL for `@ponder/client` / Drizzle — must be `.../sql` */
export function getPonderSqlUrl(): string {
  const s = normalizePonderEnv(process.env.NEXT_PUBLIC_PONDER_URL);
  if (!s) return '';
  return s.endsWith('/sql') ? s : `${s}/sql`;
}
